import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'idcoder-learn-dark';

export function isLearnViewPath(pathname: string) {
  return /\/courses\/[^/]+\/topics\//.test(pathname)
    || /\/courses\/[^/]+\/assessments\//.test(pathname)
    || /\/labs\/[^/]+\/topics\//.test(pathname)
    || /^\/labs\/[^/]+$/.test(pathname);
}

export function useLearnDarkMode() {
  const { pathname } = useLocation();
  const onLearnView = isLearnViewPath(pathname);
  const [dark, setDarkState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) !== '0';
    } catch {
      return true;
    }
  });

  const setDark = useCallback((next: boolean) => {
    setDarkState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
    } catch {
      /* ignore quota / private mode */
    }
  }, []);

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key === STORAGE_KEY) setDarkState(event.newValue !== '0');
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  useEffect(() => {
    if (onLearnView && dark) {
      document.documentElement.setAttribute('data-learn-dark', '1');
    } else {
      document.documentElement.removeAttribute('data-learn-dark');
    }
    return () => document.documentElement.removeAttribute('data-learn-dark');
  }, [dark, onLearnView]);

  return { dark, setDark, onLearnView };
}
